var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 54"}},[_c('path',{attrs:{"d":"M30.556,0H3.318A3.321,3.321,0,0,0,0,3.31V50.69A3.321,3.321,0,0,0,3.318,54H36.682A3.321,3.321,0,0,0,40,50.69V10.24Zm.783,4.95,4.139,4.49H31.339Zm5.874,45.74a.533.533,0,0,1-.533.53H3.318a.532.532,0,0,1-.531-.53V3.31a.532.532,0,0,1,.531-.53H28.55v8.05a1.392,1.392,0,0,0,1.394,1.39h7.274V50.69Z","fill":"#e5e5e5"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4847422","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/elements/FileIcon.vue
// module id = null
// module chunks = 